import TabsController from '../../tabs_controller'

// 費用種別タブ（入居金/月額）の表示切替。切替ロジックの本体は TabsController 側にある。
export default class extends TabsController {
  datasetKey () {
    return 'feeType'
  }

  // テンプレート（common/component.rb の tab_html_options）の data-action が参照するaction名
  switchFeeType (event) {
    this.switchTab(event)
  }
}
